module.exports = __webpack_public_path__ + "img/5.930fd11c.jpg";